import { checkItems, SegmentationTargets } from '@atlassian/company-hub-common';

import {
	Alignment,
	type CardsExtensionParameters,
	CardSize,
	CardsLayout,
	Orientation,
} from '../../types';

const checkIsParameterValueValid = (parameter: any, expectedValues: any[]) => {
	return expectedValues.includes(parameter) ? parameter : null;
};

const checkSize = (size: CardSize) =>
	checkIsParameterValueValid(size, [CardSize.SMALL, CardSize.MEDIUM, CardSize.LARGE]);

const checkLayout = (layout: CardsLayout) =>
	checkIsParameterValueValid(layout, [
		CardsLayout.FIXED_IMAGE_HEIGHT,
		CardsLayout.FLEXIBLE_IMAGE_HEIGHT,
	]);

export type ValidatedLinkCardsParameters = CardsExtensionParameters &
	Required<Pick<CardsExtensionParameters, 'alignment' | 'orientation'>>;

export const useValidateRequiredCardsParameters = (
	currentParameters: any,
): ValidatedLinkCardsParameters => {
	const validatedCards = checkItems(currentParameters.cards);

	const validatedSize = checkSize(currentParameters.size);

	const validatedLayout = checkLayout(currentParameters.layout);

	const validatedRequiredParameters = {
		...currentParameters,
		size: validatedSize || CardSize.MEDIUM,
		cards: validatedCards || [],
		layout: validatedLayout || CardsLayout.FLEXIBLE_IMAGE_HEIGHT,
	};

	const { orientation, alignment, isAutoscrollEnabled } = validatedRequiredParameters;

	return {
		...validatedRequiredParameters,
		// if alignment is not available (cards created before alignment), default to center
		alignment: alignment ?? Alignment.CENTER,
		// if orientation is not available (cards created before orientation), default to stacked
		orientation: orientation ?? Orientation.STACKED,
		// if orientation is stacked, default to false
		...{
			isAutoscrollEnabled: orientation === Orientation.STACKED ? false : isAutoscrollEnabled,
		},
		// if audience segmentation new format is enabled and params are outdated, use the first card's audience segmentation group ids
		audienceSegmentationGroupIds:
			currentParameters.segmentationTarget === SegmentationTargets.ALL &&
			currentParameters.audienceSegmentationGroupIds === undefined
				? currentParameters.cards[0]?.audienceSegmentationGroupIds
				: currentParameters?.audienceSegmentationGroupIds,
	};
};
